import React, { useContext, useEffect, useState } from 'react'
import { ProjectContext } from '../../../../context/ProjectContext'
import { Meeting } from './meeting'

export function GridByMeeting() {
  const { meetings, filteredNotes, showDuplicates, needsFilters } = useContext(ProjectContext)
  const [groupNotesByMeetings, setGroupNotesByMeetings] = useState([])

  useEffect(() => {
    const meetingsWithNotes = []
    const notesWithNoMeetings = filteredNotes.filter((note) => !note.meetingId)
    if (notesWithNoMeetings.length) {
      // General Notes
      const sortedNotes = [...notesWithNoMeetings]
      if (needsFilters.sort === 'popular') {
        // Sort by meetings_count (for clusters) in descending order
        sortedNotes.sort((a, b) => {
          // If items have meetings_count (clustered items), sort by that first
          if (a.meetings_count && b.meetings_count) {
            return b.meetings_count - a.meetings_count
          }
          // If only a has meetings_count, prioritize a
          else if (a.meetings_count) {
            return -1
          }
          // If only b has meetings_count, prioritize b
          else if (b.meetings_count) {
            return 1
          }
          // Otherwise sort by created_at as fallback
          return (b.created_at || 0) - (a.created_at || 0)
        })
      } else if (needsFilters.sort === 'recent') {
        // Sort by created_at timestamp (newer first)
        sortedNotes.sort((a, b) => (b.created_at || 0) - (a.created_at || 0))
      }
      meetingsWithNotes.push({ id: 0, notes: sortedNotes })
    }

    for (const meet of meetings) {
      let notesByMeeting = filteredNotes.filter((note) => note.meetingId === meet?.id)
      notesByMeeting = notesByMeeting.filter((note) => showDuplicates || !note.duplicate)

      if (needsFilters.sort === 'popular') {
        // Sort by meetings_count (for clusters) in descending order
        notesByMeeting.sort((a, b) => {
          // If items have meetings_count (clustered items), sort by that first
          if (a.meetings_count && b.meetings_count) {
            return b.meetings_count - a.meetings_count
          }
          // If only a has meetings_count, prioritize a
          else if (a.meetings_count) {
            return -1
          }
          // If only b has meetings_count, prioritize b
          else if (b.meetings_count) {
            return 1
          }
          // Otherwise sort by created_at as fallback
          return (b.created_at || 0) - (a.created_at || 0)
        })
      } else if (needsFilters.sort === 'recent') {
        // Sort by created_at timestamp (newer first)
        notesByMeeting.sort((a, b) => (b.created_at || 0) - (a.created_at || 0))
      }

      meetingsWithNotes.push({ ...meet, notes: notesByMeeting })
    }
    setGroupNotesByMeetings(meetingsWithNotes)
  }, [meetings, filteredNotes, showDuplicates, needsFilters])

  return groupNotesByMeetings.map((meeting) => <Meeting meeting={meeting} key={meeting.id} />)
}
